var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"in-loader",style:(_vm.height.trim() != '' ? `height: ${_vm.height}` : '')},[_c('Lottie',{attrs:{"options":_vm.defaultOptions},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }